"use strict";
function $09e991522ca7e64e$export$d0cc010c49859b05() {
    if (window.innerWidth >= 1200) window.location.hash = "";
}
window.addEventListener("resize", $09e991522ca7e64e$export$d0cc010c49859b05);


//# sourceMappingURL=index.18135474.js.map
